import { useEffect } from 'react';
import { FormikValues } from 'formik';

export function useApplyFieldDefaultValue(
  formik: FormikValues,
  valueId: string,
  isVisible: boolean,
  defaultValue?: string | number | string[],
  isMultiSelect?: boolean
) {
  useEffect(() => {
    if (!isVisible) return;

    const currentValue = formik.values[valueId];
    const hasValue = currentValue !== undefined && currentValue !== null;

    if (!hasValue && defaultValue !== undefined) {
      let normalizedValue: string | number | string[];

      if (isMultiSelect) {
        normalizedValue = Array.isArray(defaultValue)
          ? defaultValue
          : [String(defaultValue)];
      } else {
        normalizedValue = defaultValue;
      }

      formik.handleChange({
        target: { name: valueId, value: normalizedValue },
      });
    }
    // eslint-disable-next-line 
  }, [isVisible]);
}